module.exports = __webpack_public_path__ + "img/picklebuzz-6ed25b9d-2f33-4e67-41e6-08d9582e9481.png";